import { render, staticRenderFns } from "./TaggedNotificationRuleListModal.vue?vue&type=template&id=20ea7a47&"
import script from "./TaggedNotificationRuleListModal.vue?vue&type=script&lang=js&"
export * from "./TaggedNotificationRuleListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ea7a47')) {
      api.createRecord('20ea7a47', component.options)
    } else {
      api.reload('20ea7a47', component.options)
    }
    module.hot.accept("./TaggedNotificationRuleListModal.vue?vue&type=template&id=20ea7a47&", function () {
      api.rerender('20ea7a47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/tags/TaggedNotificationRuleListModal.vue"
export default component.exports